import { memo, useCallback, useEffect } from 'react';
import { teaseNotificationsComponentDef } from 'navigation-components/config';
import { useOnFunctionCalled } from 'navigation-components/consumer/hooks';
import { handleWebsocketNotification } from './handleWebsocketNotification';
import { getPrimaryTabUtil } from '../../utils/PrimaryTabUtil';
export const BrowserNotificationsRealtime = /*#__PURE__*/memo(() => {
  const {
    registerCallback
  } = useOnFunctionCalled(teaseNotificationsComponentDef);
  const onNotification = useCallback(notification => {
    handleWebsocketNotification(notification.notification, getPrimaryTabUtil().isPrimary);
  }, []);
  useEffect(() => registerCallback('onNewNotification', onNotification), [onNotification, registerCallback]);
  return null;
});